import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowCounterClockwiseFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowCounterClockwiseFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M13.75 2.495c-5.24 0-9.5 4.26-9.5 9.5v1.09l-3.5-2.5v3.69l5 3.57 5-3.57v-3.69l-3.5 2.5v-1.08c0-3.58 2.92-6.5 6.5-6.5s6.5 2.92 6.5 6.5-2.92 6.5-6.5 6.5h-.5v3h.5c5.24 0 9.5-4.26 9.5-9.5s-4.26-9.5-9.5-9.5v-.01Z" fill="currentColor" />
    </svg>;
}) as ForwardedIconComponent);
export default ArrowCounterClockwiseFilled;